import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createHoliday } from "api/apiHelper";
import Card from "components/Card";
import { toast } from "react-toastify";

const CreateHoliday = () => {
  const [holidayData, setHolidayData] = useState({
    name: "",
    date: "",
  });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHolidayData({
      ...holidayData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createHoliday(holidayData);
      toast.success("Holiday created successfully!");
      navigate("/profile"); // Redirect to the holiday list after creation.
    } catch (error) {
      console.error("Error creating holiday", error);
      toast.error("Error creating holiday");
    }
  };

  return (
    <Card extra="w-full p-6 my-5">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Holiday Name
          </label>
          <input
            type="text"
            name="name"
            value={holidayData.name}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Date
          </label>
          <input
            type="date"
            name="date"
            value={holidayData.date}
            onChange={handleChange}
            className="mb-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm"
            required
          />
        </div>
        <button
          type="submit"
          className="rounded bg-brand-500 px-4 py-2 text-white hover:bg-brand-600"
        >
          Create Holiday
        </button>
      </form>
    </Card>
  );
};

export default CreateHoliday;
